import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import appImage from '../../imagens/funcionalidades/aniversariantes.svg';
import estoqueComprasImage from '../../imagens/funcionalidades/comprasxvendas.svg';
import dashboardRecebimentoImage from '../../imagens/funcionalidades/dashboardrecebimento.svg';
import condicionalImage from '../../imagens/funcionalidades/condicional.svg';
import appGestorImage from '../../imagens/funcionalidades/appgestor.svg';
import pdvImage from '../../imagens/funcionalidades/pdv.svg';
import clienteImage from '../../imagens/funcionalidades/cliente.svg';
import ecomerceImage from '../../imagens/funcionalidades/ecommerce.svg';
import nfceImage from '../../imagens/funcionalidades/nfce.svg';
import {
  faBoxOpen,
  faCashRegister,
  faChartLine,
  faFileInvoice,
  faRobot,
  faShoppingBag,
  faUsers,
  faVideo,
  faTags
} from '@fortawesome/free-solid-svg-icons';
import './FeaturesSection.css';

const FeaturesSection = ({ onContactClick }) => {
  const features = [
    {
      id: 'condicionais',
      icon: faTags,
      badge: 'Condicionais',
      title: 'A gestão de condicionais mais completa do mercado',
      description: 'Reduza perdas, controle envios e acompanhe o histórico de cada cliente em tempo real. Tudo integrado ao seu estoque.',
      bullets: [
        'Controle total de envios, retornos e vendas',
        'Alerta automático de peças já enviadas',
        'Limites personalizados por cliente',
        'Históricos e análises de desempenho e conversão',
      ],
      cta: 'Solicite uma Demonstração',
      image: condicionalImage,
      mockupLines: [],
    },
    {
      id: 'vendas',
      icon: faCashRegister,
      badge: 'PDV & Vendas',
      title: 'PDV ágil e completo para sua operação de vendas',
      description: 'Do atendimento ao fechamento da venda com rapidez e praticidade. Controle de caixas, trocas e créditos sem complicação.',
      bullets: [
        'PDV intuitivo com gestão de trocas e cashback',
        'Abertura e fechamento de caixa simplificados',
        'Múltiplos caixas por loja, com auditoria e conferência',
        'Análises completas diretamente no app',
      ],
      cta: 'Solicite uma Demonstração',
      image: pdvImage,
      mockupLines: [],
    },
    {
      id: 'financeiro',
      icon: faChartLine,
      badge: 'Financeiro',
      title: 'Controle financeiro exato e descomplicado',
      description: 'Tudo em um só lugar: crediário, cobrança, contas a pagar, recebíveis e fluxo de caixa.',
      bullets: [
        'Crediário próprio e carnê com cobrança e análise de recebimento',
        'Contas a pagar e fornecedores',
        'Gerenciamento de recebíveis de cartões',
        'Análise de fluxo de caixa e DRE',
      ],
      cta: 'Solicite uma Demonstração',
      image: dashboardRecebimentoImage,
      mockupLines: [],
    },
    {
      id: 'estoque',
      icon: faBoxOpen,
      badge: 'Estoque & Compras',
      title: 'Cadastre uma vez, controle toda a grade',
      description: 'Crie o produto com todas as cores e tamanhos de uma vez. Etiquetas, transferências e compras — tudo integrado.',
      bullets: [
        'Grade de tamanhos e cores com fotos',
        'Impressão de etiquetas com código de barras',
        'Transferências entre filiais',
        'Análises para reposição inteligente',
      ],
      cta: 'Solicite uma Demonstração',
      image: estoqueComprasImage,
      imageClass: 'fs-row__image--desktop',
      mockupLines: [],
    },
    // {
    //   id: 'lives',
    //   icon: faVideo,
    //   badge: 'Live Shop',
    //   title: 'Controle suas vendas ao vivo sem perder oportunidades',
    //   description: 'Adicione o @ dos clientes direto nos produtos em tempo real. Finalize as vendas sem precisar redigitar nada.',
    //   bullets: [
    //     'Adicione @ dos clientes nos produtos ao vivo',
    //     'Finalize vendas sem redigitar',
    //     'Veja quais clientes compraram cada peça',
    //     'Integrado ao estoque e PDV',
    //   ],
    //   cta: 'Solicite uma Demonstração',
    //   mockupLines: [
    //     { w: '55%', label: 'Live em andamento — 142 viewers' },
    //     { w: '65%', label: '@ana_santos — Vestido Floral' },
    //     { w: '50%', label: '@ju_moda — Blusa Listrada (P)' },
    //     { w: '70%', label: '14 vendas registradas' },
    //   ],
    // },
    {
      id: 'app-gestor',
      icon: faRobot,
      badge: 'App Gestor',
      title: 'Controle seu negócio de qualquer lugar.',
      description: 'Acompanhe indicadores de vendas e condicionais em tempo real.',
      bullets: [
        'Análise de condicional e vendas',
        'Monitoramento de metas',
        'Comparativos e taxas de conversão',
        'Gerenciamento remoto de liberações de permissões',
      ],
      cta: 'Solicite uma Demonstração',
      image: appGestorImage,
      imageClass: 'fs-row__image--smartphone',
      mockupLines: [],

    },
    {
      id: 'app-ia',
      icon: faRobot,
      badge: 'App Vendedor com IA',
      title: 'Um app que realmente ajuda a vender',
      description: 'IA que sugere peças conforme o perfil do cliente e o estoque disponível.',
      bullets: [
        'Catálogo digital personalizado por cliente',
        'Envio de condicionais',
        'Consulta de preços e estoques',
        'Performance do vendedor e ações de vendas',
      ],
      cta: 'Solicite uma Demonstração',
      image: appImage,
      mockupLines: [],

    },
    {
      id: 'ecommerce',
      icon: faShoppingBag,
      badge: 'E-commerce',
      title: 'Loja física e virtual com estoque 100% integrado',
      description: 'Venda na loja física e nos principais marketplaces com estoques sincronizados automaticamente, evitando rupturas e perdas de vendas.',
      bullets: [
        'Integração com marketplaces de moda',
        'Sincronização de estoque, preços e pedidos',
        'Emissão de venda e nota com poucos cliques',
        'Gestão unificada de todos os canais',
      ],
      cta: 'Solicite uma Demonstração',
      image: ecomerceImage,
      imageClass: 'fs-row__image--square',
      mockupLines: [],
    },
    {
      id: 'clientes',
      icon: faUsers,
      badge: 'Clientes',
      title: 'Conheça cada cliente como ninguém',
      description: 'Acompanhe manequim, preferências, histórico de compras e aniversário. Fidelize com ações personalizadas e aumente o ticket médio.',
      bullets: [
        'Cadastro de manequim e familiares (dependentes)',
        'Histórico de vendas e ranking de clientes',
        'Alertas de aniversário para ações exclusivas',
        'Análise de conversão de condicionais',
      ],
      cta: 'Solicite uma Demonstração',
      image: clienteImage,
      mockupLines: [],
    },
    {
      id: 'nota-fiscal',
      icon: faFileInvoice,
      badge: 'Nota Fiscal',
      title: 'Emissão de notas com rapidez e praticidade',
      description: 'Emitir nota fiscal não pode ser uma dor de cabeça.',
      bullets: [
        'NF-e e NFC-e em poucos cliques',
        'Devoluções e trocas simplificadas',
        'Envio de arquivos para contabilidade',
        'Total conformidade fiscal',
      ],
      cta: 'Solicite uma Demonstração',
      image: nfceImage,
      mockupLines: [],
    },
  ];

  return (
    <div id="funcionalidades" className="fs-showcase">
      {/* Cabeçalho — usa as mesmas classes do componente Section */}
      <div className="container">
        <div className="section-header section-header--centered">
          <span className="section-subtitle">FUNCIONALIDADES</span>
          <h2 className="section-title">Tudo o que você precisa em um só sistema</h2>
          <p className="section-description">
            Soluções completas e integradas para transformar a gestão da sua loja de moda
          </p>
        </div>
      </div>

      {/* Linhas de funcionalidades */}
      {features.map((feature, index) => (
        <div
          key={feature.id}
          className={`fs-row ${index % 2 === 0 ? 'fs-row--light' : 'fs-row--subtle'
            }`}
        >
          <div className="container fs-row__inner">
            {/* Texto */}
            <div className="fs-row__text">
              <div className="fs-row__badge">
                <FontAwesomeIcon icon={feature.icon} />
                <span>{feature.badge}</span>
              </div>
              <h3 className="fs-row__title">{feature.title}</h3>
              <p className="fs-row__description">{feature.description}</p>
              <ul className="fs-row__bullets">
                {feature.bullets.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
              <button
                className="fs-row__cta"
                onClick={onContactClick}
              >
                {feature.cta} →
              </button>
            </div>

            {/* Mockup */}
            <div className="fs-row__visual">
              {feature.image ? (
                <div
                  className={`fs-row__image-frame${feature.imageClass ? ` ${feature.imageClass}` : ''}`}
                >
                  <img
                    src={feature.image}
                    alt={feature.badge}
                    className={`fs-row__image${feature.imageClass ? ` ${feature.imageClass}` : ''}`}
                  />
                </div>
              ) : (
                <div className="fs-mockup">
                  <div className="fs-mockup__bar">
                    <span /><span /><span />
                  </div>
                  <div className="fs-mockup__badge">
                    <FontAwesomeIcon icon={feature.icon} />
                    <span>{feature.badge}</span>
                  </div>
                  <div className="fs-mockup__lines">
                    {feature.mockupLines.map((line, i) => (
                      <div key={i} className="fs-mockup__line-group">
                        <div
                          className="fs-mockup__line fs-mockup__line--label"
                        />
                        <div
                          className="fs-mockup__line fs-mockup__line--value"
                          style={{ width: line.w }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturesSection;

